module.exports = __webpack_public_path__ + "img/portraits_27_V.ef053a1a.webp";